
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  AllServiceLevelWithFeesResource,
  ServiceLevelChangeRequest,
  ServiceLevelFeaturesResource,
  ServiceLevelStatusResource,
} from '../models';
import {
    AllServiceLevelWithFeesResourceFromJSON,
    AllServiceLevelWithFeesResourceToJSON,
    ServiceLevelChangeRequestFromJSON,
    ServiceLevelChangeRequestToJSON,
    ServiceLevelFeaturesResourceFromJSON,
    ServiceLevelFeaturesResourceToJSON,
    ServiceLevelStatusResourceFromJSON,
    ServiceLevelStatusResourceToJSON,
} from '../models';

export interface GetAllServiceLevelDefinitionsForOrganizationRequest {
    organizationId: string;
}

export interface GetServiceLevelFeaturesRequest {
    organizationId: string;
}

export interface GetStatusOnServiceLevelForOrganizationRequest {
    organizationId: string;
}

export interface RequestChangeOnServiceLevelForOrganizationRequest {
    organizationId: string;
    serviceLevelChangeRequest: ServiceLevelChangeRequest;
}

/**
 * 
 */
export class ServiceLevelApi extends runtime.BaseAPI {

    /**
     * This endpoint would give information on all the service levels available on the platform, with their associated standard fees.
          */
    async getAllServiceLevelDefinitionsForOrganizationRaw(requestParameters: GetAllServiceLevelDefinitionsForOrganizationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<AllServiceLevelWithFeesResource>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling getAllServiceLevelDefinitionsForOrganization().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<AllServiceLevelWithFeesResource>({
            path: `/client-settings/api/organization/{organizationId}/service-level/all`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=AllServiceLevelWithFeesResourceFromJSON(response._data); }
        return response;
    }

    /**
     * This endpoint would give information on all the service levels available on the platform, with their associated standard fees.
          */
    async getAllServiceLevelDefinitionsForOrganization(requestParameters: GetAllServiceLevelDefinitionsForOrganizationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<AllServiceLevelWithFeesResource> {
        const response = await this.getAllServiceLevelDefinitionsForOrganizationRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * This endpoint returns the service level features of an organization
          */
    async getServiceLevelFeaturesRaw(requestParameters: GetServiceLevelFeaturesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ServiceLevelFeaturesResource>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling getServiceLevelFeatures().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ServiceLevelFeaturesResource>({
            path: `/client-settings/api/organization/{organizationId}/service-level-features`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ServiceLevelFeaturesResourceFromJSON(response._data); }
        return response;
    }

    /**
     * This endpoint returns the service level features of an organization
          */
    async getServiceLevelFeatures(requestParameters: GetServiceLevelFeaturesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ServiceLevelFeaturesResource> {
        const response = await this.getServiceLevelFeaturesRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * This endpoint gives an overall status on the options of the organization service level. It informs about the current service level and possible transitions. If the transition to another service level is not possible, an error code with the reason is given. 
          */
    async getStatusOnServiceLevelForOrganizationRaw(requestParameters: GetStatusOnServiceLevelForOrganizationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ServiceLevelStatusResource>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling getStatusOnServiceLevelForOrganization().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ServiceLevelStatusResource>({
            path: `/client-settings/api/organization/{organizationId}/service-level/status`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ServiceLevelStatusResourceFromJSON(response._data); }
        return response;
    }

    /**
     * This endpoint gives an overall status on the options of the organization service level. It informs about the current service level and possible transitions. If the transition to another service level is not possible, an error code with the reason is given. 
          */
    async getStatusOnServiceLevelForOrganization(requestParameters: GetStatusOnServiceLevelForOrganizationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ServiceLevelStatusResource> {
        const response = await this.getStatusOnServiceLevelForOrganizationRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Request the transition for the given organization to a new service level. The request needs to be validated before the organization upgrades/downgrades to the requested service level. 
          */
    async requestChangeOnServiceLevelForOrganizationRaw(requestParameters: RequestChangeOnServiceLevelForOrganizationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling requestChangeOnServiceLevelForOrganization().'
            );
        }

        if (requestParameters['serviceLevelChangeRequest'] == null) {
            throw new runtime.RequiredError(
                'serviceLevelChangeRequest',
                'Required parameter "serviceLevelChangeRequest" was null or undefined when calling requestChangeOnServiceLevelForOrganization().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/client-settings/api/organization/{organizationId}/service-level/request`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ServiceLevelChangeRequestToJSON(requestParameters['serviceLevelChangeRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Request the transition for the given organization to a new service level. The request needs to be validated before the organization upgrades/downgrades to the requested service level. 
          */
    async requestChangeOnServiceLevelForOrganization(requestParameters: RequestChangeOnServiceLevelForOrganizationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.requestChangeOnServiceLevelForOrganizationRaw(requestParameters, initOverrides);
    }

}
